import { flow, makeObservable, observable } from 'mobx';
import { GlobalStore } from '../../../stores';
import { LinkedInService } from '../services/linkedInService';

export class LinkedInStore {
  private globalStore: GlobalStore;
  private linkedInService: LinkedInService;
  public linkedInCreds: any;


  constructor(globalStore) {
    this.globalStore = globalStore;
    this.linkedInService = new LinkedInService();

    makeObservable(this, {
      linkedInCreds: observable,
      retriveTokenWithOAuthToken: flow,
      handleTokenCallback: flow,
    });
  }

  async getCreds() {
    const response = await this.linkedInService.getCreds();
    this.linkedInCreds = response?.data;
  }

  *retriveTokenWithOAuthToken(brand, host) {
    yield this.linkedInService.retrieveTokenWithOAuthCode(
      brand,
      host,
      this.linkedInCreds?.clientId
    );
  }

  *handleTokenCallback(code: string) {
    yield this.linkedInService.handleCallBack(code);
  }
}
